import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import BookingSuccess from "@/pages/BookingSuccess";
import Admin from "@/pages/Admin";
import ZonePage from "@/pages/ZonePage";
import MenuPage from "@/pages/MenuPage";
import GalleryPage from "@/pages/GalleryPage";

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/zones/:key" element={<ZonePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
